import React from 'react'
import DialogBaseCC from './DialogBaseCC'
import { DIALOG_ID } from './constant'
import { useTranslation } from 'react-i18next'
import { Button, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material'
import { clearConfirmRefreshTimer } from 'services/sessionTimerService'
import { getRefreshToken } from 'utils/cookies'
import { setCloseDialogCC } from 'utils/helpers'
import { refreshTokenWrapper } from 'api/authAxios'

const DialogConfirmRefreshToken = () => {
    const { t } = useTranslation()

    const handleRefreshToken = () => {
        clearConfirmRefreshTimer()
        refreshTokenWrapper(getRefreshToken(), false)
        setCloseDialogCC()
    }

    return (
        <DialogBaseCC id={DIALOG_ID.CONFIRM_REFRESH_TOKEN} title={t('dialog.refreshSection.title')} customClose={handleRefreshToken}>
            <DialogContent>
                <DialogContentText>
                    <Typography>{t('dialog.refreshSection.content')}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button type='submit' onClick={handleRefreshToken}>{t('actions.continue')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogConfirmRefreshToken
